import moment from "moment";
import axios from "axios";
import Vue from "vue";
import toast from "../../template/layout/utility/sa-toast";
export default {
	inject: ["openShowModalLoading", "closeShowModalLoading"],
	data() {
		return {
			user: null,
		};
	},
	mounted() {
		this.user = JSON.parse(sessionStorage.getItem("user"));
	},
	methods: {
		formatFloat(value, numberDigit) {
			if (value) {
				return value.toFixed(numberDigit);
			} else {
				return "---";
			}
		},
		formatDateTime(value) {
			if (value || value === 0) {
				return moment(new Date(value)).format("DD-MM-YYYY HH:mm:ss");
			} else {
				return "---";
			}
		},
		formatDateTimeCustom(value, formato) {
			if (value) {
				return moment(new Date(value)).format(formato).toUpperCase();
			} else {
				return null;
			}
		},
		formatDate(value) {
			if (value || value === 0) {
				return moment(new Date(value)).format("DD/MM/YYYY");
			} else {
				return "---";
			}
		},
		formatTime(value) {
			if (value || value === 0) {
				return moment(new Date(value)).format("HH:mm");
			} else {
				return "---";
			}
		},
		padStartCustom(value, number, carattere) {
			return String(value).padStart(number, carattere);
		},
		parseFormatDateTime(value, format) {
			if (value) {
				return moment(value, format).toDate();
			} else {
				return "---";
			}
		},
		verificaPermessi(utente, idSezione, permessoDaVerificare) {
			let returnValue = false;
			if (utente !== null) {
				let gruppo = utente.gruppo;
				if (gruppo) {
					if (gruppo !== null) {
						if (gruppo.permessi) {
							gruppo.permessi.forEach((sezione) => {
								if (sezione.id === idSezione) {
									sezione.permessi.forEach((permesso) => {
										if (permesso.permesso === permessoDaVerificare) {
											returnValue = permesso.attivo;
										}
									});
								}
							});
						}
					}
				}
			}
			return returnValue;
		},
		verificaPermessiByIdSezionePermesso(idSezione, permessoDaVerificare) {
			let returnValue = false;
			// let x = sessionStorage.getItem("user");
			// console.log(x);
			// console.log(Vue.prototype.user);
			let gruppo = Vue.prototype.user.gruppo;
			if (gruppo) {
				if (gruppo !== null) {
					if (gruppo.permessi) {
						gruppo.permessi.forEach((sezione) => {
							if (sezione.id === idSezione) {
								sezione.permessi.forEach((permesso) => {
									if (permesso.permesso === permessoDaVerificare) {
										returnValue = permesso.attivo;
									}
								});
							}
						});
					}
				}
			}

			return returnValue;
		},
		getLabelTraduora(value) {
			return this.$i18n.t(value);
		},
		traduciConValue(label, value) {
			return this.$i18n.t(label, { variable: value });
		},
		getColorByFirma(firma) {
			let colore = firma ? "sa-tab-title-success text-success" : "sa-tab-title-danger text-danger";

			return colore;
		},
		getIconByFirma(firma) {
			let icon = firma ? "check2" : "exclamation-triangle";
			return icon;
		},
		getColorByEta(eta) {
			let colore = "sa-maggiorenne-true";
			if (!this.isMaggiorenne(eta)) {
				colore = "sa-maggiorenne-false";
			} else {
				colore = "sa-maggiorenne-true";
			}
			return colore;
		},



		getLinkPatient(utente, idPaziente) {
			if (utente.gruppo) {
				if (utente.gruppo.menuGruppo) {
					if (utente.gruppo.menuGruppo.length == 1) {
						if (utente.gruppo.menuGruppo[0].primaryKey === "homestudiomedico") {
							return "/paziente/view/" + idPaziente;
						} else if (utente.gruppo.menuGruppo[0].primaryKey === "pazienti") {
							return "view/" + idPaziente;
						} else {
							return "homepaziente";
						}
					} else {
						return "";
					}
				} else {
					return "";
				}
			} else {
				return "";
			}
		},
		// calcoloEta(value) {
		//     if (value) {
		//         let today = new Date();
		//         let birthDate = new Date(value);
		//         let age = today.getFullYear() - birthDate.getFullYear();
		//         let ageMonth = today.getMonth() - birthDate.getMonth();
		//         let ageDays = today.getDate() - birthDate.getDate();
		//         if (ageMonth < 0 || (ageMonth === 0 && today.getDate() < birthDate.getDate())) {
		//             age--;
		//             ageMonth = 12 + ageMonth;
		//         }

		//         if (ageDays < 0) {
		//             ageMonth--;
		//             ageDays = birthDate.getDate() - today.getDate();
		//         }
		//         return age + " " + this.getLabelTraduora("patient.lblYears") + " " + ageMonth + " " + this.getLabelTraduora("patient.lblMonth") + " " + ageDays + " " + this.getLabelTraduora("patient.lblDays");
		//     } else {
		//         return "---";
		//     }
		// },
		calcoloEta(value) {
			if (value) {
				let today = new Date();
				let birthDate = new Date(value);
				let daAggiungere = this.calcolaDaAggiungere(birthDate.getMonth(), birthDate.getFullYear());
				let age = today.getFullYear() - birthDate.getFullYear();
				let ageMonth = today.getMonth() - birthDate.getMonth();
				let ageDays = today.getDate() - birthDate.getDate();
				if (ageMonth < 0 || (ageMonth === 0 && today.getDate() < birthDate.getDate())) {
					age--;
					ageMonth = 12 + ageMonth;
				}

				if (ageDays < 0) {
					ageMonth--;
					//   console.log(daAggiungere);
					//   console.log(today.getDate(), " ", birthDate.getDate());
					ageDays = today.getDate() - birthDate.getDate() + daAggiungere;
				}
				//return age + " " + this.getLabelTraduora("patient.lblYears") + " " + ageMonth + " " + this.getLabelTraduora("patient.lblMonth") + " " + ageDays + " " + this.getLabelTraduora("patient.lblDays");
				return age + " Anni " + ageMonth + " Mesi " + ageDays + " Giorni";
			} else {
				return "---";
			}
		},
		calcolaDaAggiungere(mese, anno) {
			//   console.log(mese);
			let returnValue = 31;
			//   console.log(returnValue);
			if (mese == 1) {
				if ((anno % 4 == 0 && anno % 100 != 0) || anno % 400 == 0) {
					returnValue = 29;
				} else {
					returnValue = 28;
				}
			} else if (mese == 3 || mese == 5 || mese == 8 || mese == 10) {
				returnValue = 30;
			}
			return returnValue;
		},
		calcoloEtaYearOnly(dataNascita, dataRiferimento = null) {
			if (dataNascita) {
				if (dataRiferimento == null) {
					dataRiferimento = new Date();
				}
				// let today = new Date();
				let birthDate = new Date(dataNascita);
				let age = dataRiferimento.getFullYear() - birthDate.getFullYear();
				let ageMonth = dataRiferimento.getMonth() - birthDate.getMonth();
				let ageDays = dataRiferimento.getDate() - birthDate.getDate();
				if (ageMonth < 0 || (ageMonth === 0 && dataRiferimento.getDate() < birthDate.getDate())) {
					age--;
					ageMonth = 12 + ageMonth;
				}

				if (ageDays < 0) {
					ageMonth--;
					ageDays = birthDate.getDate() - dataRiferimento.getDate();
				}
				return age;
			} else {
				return "---";
			}
		},
		isMaggiorenne(value) {
			let returnValue = false;
			if (value) {
				let today = new Date();
				let birthDate = new Date(value);
				let age = today.getFullYear() - birthDate.getFullYear();
				let ageMonth = today.getMonth() - birthDate.getMonth();
				let ageDays = today.getDate() - birthDate.getDate();
				if (ageMonth < 0 || (ageMonth === 0 && today.getDate() < birthDate.getDate())) {
					age--;
					ageMonth = 12;
				}
				if (ageDays < 0) {
					ageMonth--;
					ageDays = birthDate.getDate() - today.getDate();
				}
				if (age >= 18) {
					returnValue = true;
				}
			}
			return returnValue;
		},
		isOverAge(value, number) {
			let returnValue = false;
			if (value) {
				let today = new Date();
				let birthDate = new Date(value);
				let age = today.getFullYear() - birthDate.getFullYear();
				let ageMonth = today.getMonth() - birthDate.getMonth();
				let ageDays = today.getDate() - birthDate.getDate();
				if (ageMonth < 0 || (ageMonth === 0 && today.getDate() < birthDate.getDate())) {
					age--;
					ageMonth = 12;
				}
				if (ageDays < 0) {
					ageMonth--;
					ageDays = birthDate.getDate() - today.getDate();
				}
				if (age >= number) {
					returnValue = true;
				}
			}
			return returnValue;
		},
		chekCondition(value, condizione) {
			let returnValue = true;
			if (value === condizione) {
				returnValue = false;
			}
			return returnValue;
		},
		checkDoubleCondition(value, firstCondition, secondCondition, logicoperator) {
			let returnValue = true;
			switch (logicoperator) {
				case "AND":
					if (this.chekCondition(value, firstCondition) && this.chekCondition(value, secondCondition)) {
						returnValue = false;
					}
					break;
				case "OR":
					if (!this.chekCondition(value, firstCondition) || !this.chekCondition(value, secondCondition)) {
						returnValue = false;
					}
					break;
			}
			return returnValue;
		},
		restCallGet(link, filtro = null, resultResponse, resultError = null) {
			axios.get(link, { params: filtro })
				.then((response) => {
					resultResponse(response);
				})
				.catch((err) => {
					if (resultError === null) {
						this.$bvModal
							.msgBoxOk(link + " \n" + err.message, {
								title: "ATTENZIONE",
								size: "sm",
								okVariant: "outline-danger",
								headerClass: "sa-msg-header-danger",
								footerClass: "p-2 border-top-0",
								centered: true,
							})
							.then(() => { })
							.catch((err) => {
								console.log(err);
							});
					} else {
						resultError(err);
					}
				});
		},
		restCallPost(link, body, resultResponse = null, resultError = null) {
			axios.post(link, JSON.stringify(body))
				.then((response) => {
					//resultResponse(response);
					// this.successToast(response.data.data.messaggio);
					if (resultResponse) {
						resultResponse(response);
					} else {
						this.successToast(response.data.data.messaggio);
					}
				})
				.catch((err) => {
					if (resultError === null) {
						this.errorToast(err);
					} else {
						resultError(err);
					}
				});
		},
		restCallPut(link, body, resultResponse = null, resultError = null) {
			axios.put(link, JSON.stringify(body))
				.then((response) => {
					if (resultResponse) {
						resultResponse(response);
					} else {
						this.successToast(response.data.data.messaggio);
					}
				})
				.catch((err) => {
					console.log(err);

					if (resultError === null) {
						this.errorToast(err.response.data.messaggio);
					} else {
						resultError(err);
					}
				});
		},
		restCallDelete(link, resultResponse, resultError = null) {
			axios.delete(link)
				.then((response) => {
					resultResponse(response);
				})
				.catch((err) => {
					if (resultError === null) {
						this.$bvModal
							.msgBoxOk(link + " \n" + err.message, {
								title: "ATTENZIONE",
								size: "sm",
								okVariant: "outline-danger",
								headerClass: "sa-msg-header-danger",
								footerClass: "p-2 border-top-0",
								centered: true,
							})
							.then(() => { })
							.catch((err) => {
								console.log(err);
							});
					} else {
						resultError(err);
					}
				});
		},
		putResource(pathResource, body, resultResponse = null, resultError = null) {
			let link = process.env.VUE_APP_PATH_API + pathResource;
			axios.put(link, JSON.stringify(body))
				.then((response) => {
					if (resultResponse) {
						resultResponse(response);
					} else {
						this.successToast(response.data.data.messaggio);
					}
				})
				.catch((err) => {
					if (resultError === null) {
						this.errorToast(err.response.data.messaggio);
					} else {
						resultError(err);
					}
				});
		},
		deleteResource(pathResource, resultResponse, resultError = null) {
			let link = process.env.VUE_APP_PATH_API + pathResource;
			this.restCallDelete(link, resultResponse, resultError);
		},

		saveResource(pathResource, body, resultResponse = null, resultError = null) {
			//this.openShowModalLoading();
			let link = process.env.VUE_APP_PATH_API + pathResource;
			if (body.id === "-1" || body.id === null || body.id === undefined) {
				this.restCallPost(link, body, resultResponse, resultError);
			} else {
				link = link + "/" + body.id;
				this.restCallPut(link, body, resultResponse, resultError);
			}
		},

		loadDataResources(pathResource, params, resultResponse, resultError = null) {
			let link = process.env.VUE_APP_PATH_API + pathResource;
			axios.get(link, { params: params })
				.then((response) => {
					resultResponse(response);
				})
				.catch((error) => {
					if (resultError == null) {
						this.errorToast(error);
					} else {
						resultError(error);
					}
				});
		},
		messaggeBoxError(context, error) {
			// console.log(error);
			let messaggio = error.message ? error.message : "Errore Generico";
			if (error.response) {
				if (error.response.data) {
					messaggio = messaggio + ": " + error.response.data.messaggio;
				}
			}
			context.$bvModal
				.msgBoxOk(messaggio, { title: "ATTENZIONE", size: "sm", centered: true, okVariant: "danger", headerBgVariant: "danger" })
				.then(() => { })
				.catch(() => {
					// An error occurred
				});
		},
		getDaysOfWeekArray() {
			let returnValue = [
				{ code: "1", day: "Domenica" },
				{ code: "2", day: "Lunedì" },
				{ code: "3", day: "Martedì" },
				{ code: "4", day: "Mercoledì" },
				{ code: "5", day: "Giovedì" },
				{ code: "6", day: "Venerdì" },
				{ code: "7", day: "Sabato" },
			];
			return returnValue;
		},
		getFrequenzaDayArray() {
			let returnValue = [
				{ code: 1, text: "Primo" },
				{ code: 2, text: "Secondo" },
				{ code: 3, text: "Terzo" },
				{ code: 4, text: "Quarto" },
				{ code: 5, text: "Ultimo" },
			];
			return returnValue;
		},
		getDayOfWeek(code) {
			let returnValue = "Giorno non valido";
			let giorni = this.getDaysOfWeekArray();
			let result = giorni.filter((giorno) => giorno.code === code);
			if (result.length === 1) {
				returnValue = result[0].day;
			}
			return returnValue;
		},
		getFrequenzaDayOfWeek(code) {
			let returnValue = "Giorno non valido";
			let frequenzaDay = this.getFrequenzaDayArray();
			let result = frequenzaDay.filter((giorno) => giorno.code === code);
			if (result.length === 1) {
				returnValue = result[0].text;
			}
			return returnValue;
		},
		notAfter: function (date) {
			return date > Date.now();
		},
		notBefor: function (date) {
			return date < Date.now();
		},
		// errorToast(error) {
		// 	console.log(this);
		// 	// 1. Estrazione del messaggio di errore
		// 	let message = ["Errore non gestito!"];
		// 	if (error.response && error.response.data && error.response.data.messaggio) {
		// 		// Splitta il messaggio se contiene il carattere '#'
		// 		message = error.response.data.messaggio.split("#");
		// 	} else if (typeof error === "string") {
		// 		message = [error];
		// 	} else if (error.message) {
		// 		message = [error.message];
		// 	}

		// 	// 2. Recupero sicuro di CreateElement (h) e Toaster
		// 	// Usiamo this.$root o Vue.prototype come fallback se il mixin perde il contesto
		// 	const h = this.$createElement || (this.$root && this.$root.$createElement);
		// 	const toaster = this.$bvToast || Vue.prototype.$bvToast;

		// 	if (!toaster) {
		// 		console.error("BootstrapVue Toaster non trovato!", message);
		// 		alert(message.join("\n")); // Fallback estremo
		// 		return;
		// 	}

		// 	// 3. Creazione del contenuto (VNodes o Stringa)
		// 	let vNodesMsg;
		// 	if (typeof h === "function") {
		// 		const listItems = [];
		// 		message.forEach((element) => {
		// 			if (element.trim() !== "") {
		// 				listItems.push(h("li", { textAlign: "left" }, element));
		// 			}
		// 		});
		// 		vNodesMsg = h("ul", { style: "margin-left: -18px; margin-bottom: 0;" }, listItems);
		// 	} else {
		// 		vNodesMsg = message.join("\n");
		// 	}

		// 	// 4. Lancio del Toast
		// 	toaster.toast([vNodesMsg], {
		// 		title: "Attenzione",
		// 		autoHideDelay: 5000,
		// 		variant: "danger",
		// 		solid: true,
		// 		appendToast: true,
		// 	});

		// 	// 5. Chiusura del caricamento (se il metodo esiste)
		// 	if (typeof this.closeShowModalLoading === "function") {
		// 		this.closeShowModalLoading();
		// 	}
		// },
		// errorToast(error) {
		// 	let message = "Errore non gestito!";
		// 	if (error.response.data.messaggio) {
		// 		message = error.response.data.messaggio.split("#");
		// 	} else if (error.response.data) {
		// 		message = error.response.data.split("#");
		// 	}
		// 	const h = this.$createElement;
		// 	const vNodesMsg = h("ul", { style: "margin-left: -18px" }, []);
		// 	console.log(message);
		// 	message.forEach((element) => {
		// 		if (element.trim() != "") {
		// 			vNodesMsg.children.push({ tag: "li", text: element });
		// 		}
		// 	});
		// 	this.$bvToast.toast([vNodesMsg], {
		// 		title: "Attenzione",
		// 		autoHideDelay: 5000,
		// 		variant: "danger",
		// 	});

		// 	this.closeShowModalLoading();
		// },
		errorToast(error) {
			// Recupera il messaggio
			let message = "Errore non gestito!";
			if (error && error.response && error.response.data && error.response.data.messaggio) {
				message = error.response.data.messaggio;
			} else if (typeof error === "string") {
				message = error;
			} else if (error && error.message) {
				message = error.message;
			}

			// Prova a recuperare il toaster da diverse sorgenti
			toast.error(message, "Attenzione");


			// if (toaster) {
			// 	toaster.toast(message);
			// } else {
			// 	console.error("BootstrapVue Toaster non trovato", message);
			// 	alert("Errore: " + message);
			// }

			// if (typeof this.closeShowModalLoading === "function") {
			// 	this.closeShowModalLoading();
			// }
		},
		successToast(message) {
			if (!message) {
				message = "Operazione avvenuta con successo!";
			}
			toast.success(message, "Successo");

			this.closeShowModalLoading();
		},
	},
};
